import { Box, chakra, Text} from "@chakra-ui/react";

const UserProfileContainer = chakra(Box, {
  baseStyle: {
    overflow: "auto",
    width:'100%',
    p: { base: 2, sm: 4 },
  },
});

const StyledUserProfileSubHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "18px", md: "20px" },
    mt: "5px",
  },
});
const StyledSectionTitle = chakra(Text, {
  baseStyle: {
  fontSize: "20px",
  fontWeight: "500",
  mb: 4,
  color:"#18191B",
  
  },
  });

export { UserProfileContainer, StyledUserProfileSubHeading,StyledSectionTitle };
